import React from "react";
import SellexxWebHome from "./views/home/home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SearchResults from "./views/search/search-results-view";
import CategoryView from "./views/categories/category-view";
import ProductDetailPage from "./views/products/subviews/product-detail-page";
import LegalPage from "./components/legal-page";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SellexxWebHome />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/category" element={<CategoryView />} />
        <Route path="/product/:productId" element={<ProductDetailPage />} />
        <Route path="/legal/:page" element={<LegalPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
